module.exports = __webpack_public_path__ + "img/voucher-white.46d74b8d.svg";